module.exports = __webpack_public_path__ + "img/silver4.30848dde.png";